	const baseDev = `${window.location.protocol}//test.com`, //开发环境
		// basePro = `${window.location.protocol}//10.82.15.161:8088/portal`; //生产环境 ，目前暂时一样
		// basePro = `${window.location.protocol}//10.82.16.168:8088/portal`; //生产环境（测试）
		basePro = `${window.location.protocol}//10.82.200.3:8088/portal`; //生产环境（测试）

// console.log(process.env.NODE_ENV);
// console.log('baseDev', baseDev);

const baseUrl = process.env.NODE_ENV === "development" ? baseDev : basePro;

export default baseUrl;



// WEBPACK FOOTER //
// ./src/api/baseUrl.js